import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';

import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule, NumberPlateViewComponent } from '@blcloud/bl-ng-ui-component';
import { WebReserveResource, WebReserveLinkReqResource, WebReserveLinkCandidateResource,
 SnsPotentialCustomerResource, OperationHistoryLogResource, SnsShopAccountSettingResource } from '@blcloud/bl-ng-resource';
import { LoginResourceService, CustomerVehicleSearchResourceService } from '@blcloud/bl-ng-share-module';
import { SnsLinkChangeConfirmModalModule } from '@blcloud/bl-ng-vehicle-customer-module';

import { WebReserveCustomerVehicleLinkComponent } from './web-reserve-customer-vehicle-link.component';
import { WebReserveCustomerVehicleLinkService } from './web-reserve-customer-vehicle-link.service';

/**
 * Web予約顧客車両紐付モジュール
 */
@NgModule({
  imports: [
    CommonModule,
    BlNgCommonModule,
    BlNgUiComponentModule,
    SnsLinkChangeConfirmModalModule,
    AgGridModule.withComponents([
      NumberPlateViewComponent
    ]),
  ],
  declarations: [
    WebReserveCustomerVehicleLinkComponent
  ],
  entryComponents: [
    WebReserveCustomerVehicleLinkComponent
  ],
})
export class WebReserveCustomerVehicleLinkModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: WebReserveCustomerVehicleLinkModule,
      providers: [
        WebReserveResource,
        WebReserveLinkReqResource,
        WebReserveLinkCandidateResource,
        WebReserveCustomerVehicleLinkService,
        CustomerVehicleSearchResourceService,
        LoginResourceService,
        SnsShopAccountSettingResource,
        SnsPotentialCustomerResource,
        OperationHistoryLogResource,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/web-reserve-customer-vehicle-link/web-reserve-customer-vehicle-link.module.ts